import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Breadcrumbs } from './index';
import { useRouter } from 'next/router';

export const BREADCRUMBS_PORTAL_ID = 'breadcrumbs-portal';

export const BreadcrumbsPortal = () => {
    const [portalTarget, setPortalTarget] = useState<HTMLElement | null>(null);
    const router = useRouter();

    useEffect(() => {
        const checkPortalTarget = () => {
            const target = document.getElementById(BREADCRUMBS_PORTAL_ID);
            if (target) {
                setPortalTarget(target);
                return true;
            }
            return false;
        };

        if (checkPortalTarget()) {
            return;
        }

        const observer = new MutationObserver(() => {
            checkPortalTarget();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        return () => {
            observer.disconnect();
        };
    }, [router.pathname]);

    const breadcrumbs = <Breadcrumbs />;
    const target = portalTarget;

    return target ? createPortal(breadcrumbs, target) : breadcrumbs;
};
